import React from 'react';
import { Span } from 'components/Ui';
import styles from './styles.scss';

const Location = ({
  id,
  address1,
  address2,
  city,
  postalCode,
  stateOrProvinceCode,
  showId,
}) => {
  if (!id) return null;

  return (
    <p className={styles.location}>
      {`${address1}, ${city}, ${stateOrProvinceCode} ${postalCode}`}
      <br />
      {address2 && (
        <>
          <span className={styles.line2}>{`${address2}`}</span>
          <br />
        </>
      )}
      {showId && (
        <span className={styles.id}>
          <Span>Location #</Span> {id}
        </span>
      )}
    </p>
  );
};

export default Location;
